<template>
  <div class="bet-page">
    <!-- 顶部 -->
    <div class="header">
      <div class="back" @click="$router.back()">‹</div>
      <div class="title">
        分分28‑2.0
        <span class="arrow">▼</span>
      </div>
      <div class="tools">
        <span>◉</span>
        <span class="menu">☰</span>
      </div>
    </div>

    <!-- 当前开奖 -->
    <div class="issue-box">
      <div class="issue">
        <div>
          第
          <span class="blue">{{ currentPeriod }}</span>
          期开奖
        </div>
        <div class="status" :class="{ warn: countdown <= 5 && countdown > 0 }">
          {{ statusText }} {{ formatTime(countdown) }}
        </div>
      </div>
      <div class="balance">
        <div>账户余额</div>
        <strong>{{ balance }}</strong>
      </div>
    </div>

    <!-- 上一期开奖【可点击展开历史】 -->
    <div class="last-result" @click="toggleHistory">
      <span>第 <i>{{ lastDraw ? lastDraw.period : "--" }}</i> 期开奖</span>
      <div class="balls">
        <b>{{ lastDraw ? lastDraw.num1 : 0 }}</b>
        <b>{{ lastDraw ? lastDraw.num2 : 0 }}</b>
        <b>{{ lastDraw ? lastDraw.num3 : 0 }}</b>
        <em>= {{ lastDraw ? lastDraw.total : 0 }}</em>
      </div>
      <div class="result-tag">{{ lastDrawTag }}</div>
      <span class="expand-icon">{{ showHistory ? '▲' : '▼' }}</span>
    </div>

    <!-- 中间内容 -->
    <div class="content">
      <div v-if="loading" class="loading-tip">加载中...</div>

      <!-- 投注区域 -->
      <div class="bet-panel">
        <!-- 玩法 -->
        <div class="play-list">
          <div
            class="play-item"
            v-for="item in plays"
            :key="item.id"
            @click="selectPlay(item)"
            :class="{ choose:item.checked, disabled: countdown<=5 || submitting }"
          >
            <h3>{{ getBetName(item.bet_type, item.bet_sub) }}</h3>
            <p>1:{{ item.odds }}</p>
          </div>
        </div>

        <!-- 金额选择：快捷按钮 + 手动输入【美化】 -->
        <div class="money-bar">
          <button
            v-for="m in moneyList"
            :key="m"
            :class="{ active: m === Number(selectMoney) }"
            @click="changeMoney(m)"
            :disabled="submitting || countdown<=5"
          >
            ￥{{ m }}
          </button>
          <input
            class="money-input"
            v-model.number="selectMoney"
            type="number"
            placeholder="输入金额"
            :disabled="submitting || countdown<=5"
            @input="calcTotal"
          />
        </div>

        <!-- 底部下注栏【美化】 -->
        <div class="footer">
          <div class="total">
            已投 <b>{{ betCount }}</b> 单，共 <b>{{ totalAmount }}</b> 元
          </div>
          <button class="clear" @click="clearAll">清空</button>
          <button
            class="submit"
            @click="handleSubmit"
            :disabled="countdown<=5 || submitting"
          >
            {{ submitting ? '提交中...' : (countdown<=5 ? '封盘中' : '确认投注') }}
          </button>
        </div>
      </div>
    </div>

    <!-- Vue2 fixed弹窗 -->
    <div v-if="showHistory" class="history-mask" @click="closeHistory">
      <div class="history-popup" @click.stop>
        <div class="history-title">历史开奖</div>
        <div class="history-list">
          <div v-if="historyLoading" class="history-loading">加载中...</div>
          <div
            class="history-item"
            v-for="item in historyList"
            :key="item.id"
            v-else
          >
            <span class="period">第{{ item.period }}期</span>
            <div class="balls-mini">
              <b>{{ item.num1 }}</b>
              <b>{{ item.num2 }}</b>
              <b>{{ item.num3 }}</b>
              <em>= {{ item.total }}</em>
            </div>
            <div class="result-tag">{{ getResultTag(item) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'Game28',
  data(){
    return {
      loading:false,
      submitting:false,
      currentPeriod:'',
      drawTimestamp:0,
      countdown:0,
      balance:'0.00',
      lastDraw:null,
      showHistory:false,
      historyLoading:false,
      historyList:[],
      moneyList:[1,5,10,50,100,500],
      selectMoney:5,
      betCount:0,
      totalAmount:0,
      plays:[],
      timerCountDown:null,
      timerPollApi:null
    }
  },
  computed:{
    statusText(){
      if(this.countdown<=5 && this.countdown>0) return '封盘中'
      if(this.countdown<=0) return '开奖中'
      return '投注剩余'
    },
    lastDrawTag(){
      if(!this.lastDraw) return '--'
      return this.getResultTag(this.lastDraw)
    }
  },
  mounted(){
    this.fetchOdds()
    this.fetchCurrent()
    this.fetchUserInfo()

    this.timerCountDown = setInterval(()=>{
      if(this.drawTimestamp>0){
        const now = Math.floor(Date.now() / 1000)
        const remain = this.drawTimestamp - now
        this.countdown = Math.max(0, remain)
      }else{
        this.countdown = 0
      }
    },1000)

    this.timerPollApi = setInterval(()=>{
      this.fetchCurrent()
      this.fetchUserInfo()
    },3000)
  },
  beforeDestroy(){
    if(this.timerCountDown){
      clearInterval(this.timerCountDown)
      this.timerCountDown=null
    }
    if(this.timerPollApi){
      clearInterval(this.timerPollApi)
      this.timerPollApi=null
    }
  },
  methods:{
    formatTime(sec){
      sec = Number(sec || 0)
      if(sec <= 0) return '00:00'
      const m = Math.floor(sec / 60).toString().padStart(2,'0')
      const s = (sec % 60).toString().padStart(2,'0')
      return m+':'+s
    },

    parseTime(time){
      if(!time) return 0
      const num = Number(time)
      if(num > 9999999999) return Math.floor(num / 1000)
      return num
    },

    // 只输出大小单双，忽略豹子/对子/顺子/龙虎豹
    getResultTag(row){
      const size = row.is_big ===1 ? '大' : '小'
      const oddEven = row.is_single ===1 ? '单' : '双'
      return size + oddEven
    },

    toggleHistory(){
      this.showHistory = !this.showHistory
      if(this.showHistory){
        console.log('请求历史接口 /api/getDrawHistory')
        this.fetchDrawHistory()
      }
    },
    closeHistory(){
      this.showHistory = false
      this.historyList = []
    },

    async fetchDrawHistory(){
      this.historyLoading = true
      try {
        const res = await this.$apiFun.get('/api/getDrawHistory')
        console.log('getDrawHistory response:', res)
        if(res && res.code === 200){
          this.historyList = Array.isArray(res.data.list) ? res.data.list : []
        }
      } catch (e) {
        console.error('获取历史开奖失败', e)
      } finally {
        this.historyLoading = false
      }
    },

    getBetName(betType, betSub){
      const map={
        big:'大', small:'小', single:'单', double:'双',
        small_single:'小单', big_double:'大双', small_double:'小双', big_single:'大单',
        min_extreme:'极小', max_extreme:'极大', duizi:'对子', shunzi:'顺子', baozi:'豹子',
        long:'龙', hu:'虎', bao:'豹'
      }
      if(betType==='number') return (betSub||'')
      return map[betType] || betType
    },

    async fetchOdds(){
      try{
        this.loading=true
        const res = await this.$apiFun.get('/api/getOddsList')
        if(res && res.code===200){
          this.plays = (res.data || []).map(item=> ({...item, checked:false}))
        }
      }catch(e){
        console.error('赔率获取失败', e)
      }finally{
        this.loading=false
      }
    },

    // 获取用户信息，更新余额
    async fetchUserInfo(){
      try{
        const res = await this.$apiFun.get('/api/user')
        if(res && res.code === 200 && res.data){
          this.balance = res.data.balance || "0.00"
        }
      }catch(e){
        console.error('获取用户余额失败', e)
      }
    },

    async fetchCurrent(){
      try{
        const res = await this.$apiFun.get('/api/getCurrentDraw')
        if(res && res.code===200){
          const d = res.data || {}
          const cur = d.current || {}

          const period = cur.period || ''
          if(period && period !== this.currentPeriod){
            this.clearAll()
            this.currentPeriod = period
          }

          if(d.theory && d.theory.draw_timestamp){
            this.drawTimestamp = this.parseTime(d.theory.draw_timestamp)
          }else{
            this.drawTimestamp = 0
          }

          if(d.last_open) this.lastDraw = d.last_open
          // 余额不再从开奖接口拿，统一使用/api/user
        }
      }catch(e){
        console.error('当前期错误', e)
      }
    },

    changeMoney(m){
      this.selectMoney = m
      this.calcTotal()
    },

    selectPlay(item){
      if(this.countdown<=5 || this.submitting) return
      this.$set(item,'checked',!item.checked)
      this.calcTotal()
    },

    calcTotal(){
      const list = this.plays.filter(item=>item.checked)
      this.betCount = list.length
      let money = Number(this.selectMoney)||0
      if(money<0) money=0
      this.totalAmount = this.betCount * money
    },

    clearAll(){
      this.plays.forEach(item=> this.$set(item,'checked',false))
      this.betCount=0
      this.totalAmount=0
    },

    async handleSubmit(){
      if(this.countdown<=5){
        this.$parent.showTost(0,'已封盘')
        return
      }
      if(this.submitting) return

      let betMoney = Number(this.selectMoney)||0
      if(betMoney <= 0){
        this.$parent.showTost(0,'请输入有效投注金额')
        return
      }

      const selected = this.plays.filter(item=>item.checked)
      if(selected.length<=0){
        this.$parent.showTost(0,'请选择玩法')
        return
      }
      if(this.totalAmount > Number(this.balance)){
        this.$parent.showTost(0,'余额不足')
        return
      }

      const body={
        period: this.currentPeriod,
        bet_money: betMoney,
        total_amount: this.totalAmount,
        list: selected.map(item=> ({
          bet_type: item.bet_type,
          bet_sub: item.bet_sub,
          odds: item.odds
        }))
      }
      this.submitting=true
      try{
        const res = await this.$apiFun.post('/api/bet', body)
        if(res.code===200){
          this.$parent.showTost(1,'投注成功')
          this.clearAll()
          // 投注成功立刻刷新余额
          this.fetchUserInfo()
        }else{
          this.$parent.showTost(0, res.msg || '投注失败')
        }
      }catch(e){
        console.error('投注异常', e)
        this.$parent.showTost(0,'网络异常')
      }finally{
        this.submitting=false
      }
    }
  }
}
</script>

<style scoped>
*{
  box-sizing:border-box;
  margin:0;
  padding:0;
}

.bet-page{
  width:100vw;
  height:100vh;
  overflow:hidden;
  display:flex;
  flex-direction:column;
  background:#f2f5fa;
  color:#111;
  font-size:14px;
}

.header{
  height:60px;
  flex-shrink:0;
  background:#fff;
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding:0 18px;
}

.back{
  font-size:42px;
  font-weight:200;
}

.title{
  font-size:22px;
}

.arrow{
  font-size:12px;
}

.tools{
  display:flex;
  gap:20px;
  font-size:28px;
}

.issue-box{
  height:120px;
  flex-shrink:0;
  background:#fff;
  display:flex;
  justify-content:space-around;
  align-items:center;
  border-bottom:1px solid #eee;
}

.issue{
  text-align:center;
  font-size:16px;
}

.blue{
  color:#345cc5;
}

.status{
  margin-top:15px;
  font-size:18px;
  font-weight:500;
}

.status.warn{
  color:#f5222d;
  font-weight:bold;
}

.balance{
  text-align:center;
  font-size:16px;
}

.balance strong{
  display:block;
  margin-top:8px;
  font-size:24px;
  color:#ff675d;
}

.last-result{
  height:70px;
  flex-shrink:0;
  background:#fff;
  display:flex;
  align-items:center;
  gap:12px;
  padding:0 18px;
  cursor:pointer;
  user-select:none;
  border-bottom:1px solid #eee;
}

.last-result i{
  color:#325ac4;
  font-style:normal;
}

.balls{
  display:flex;
  align-items:center;
  gap:8px;
}

.balls b{
  width:38px;
  height:38px;
  border-radius:50%;
  background:linear-gradient(#00d2e9,#0084c7);
  color:#fff;
  display:flex;
  justify-content:center;
  align-items:center;
  font-size:20px;
}

.balls em{
  width:38px;
  height:38px;
  border-radius:50%;
  background:#ff663f;
  color:white;
  font-style:normal;
  display:flex;
  justify-content:center;
  align-items:center;
}

.result-tag{
  padding:4px 12px;
  background:#e8f0ff;
  color:#203985;
  border-radius:20px;
  font-weight:bold;
  font-size:15px;
}

.expand-icon{
  margin-left:auto;
  font-size:18px;
  color:#666;
}

.content{
  flex:1;
  overflow-y:auto;
}

.loading-tip{
  text-align:center;
  padding:20px;
  color:#888;
}

.bet-panel{
  flex-shrink:0;
  background:#fff;
}

.play-list{
  display:grid;
  grid-template-columns: repeat(2,1fr);
  gap:10px;
  padding:10px 12px;
  max-height: calc(100vh - 400px);
  overflow-y:auto;
}

.play-item{
  height:145px;
  background:#fff;
  border-radius:12px;
  box-shadow: 0 0 3px #ddd;
  text-align:center;
  padding-top:20px;
  transition:.2s;
}

.play-item h3{
  font-size:22px;
}

.play-item p{
  margin-top:8px;
}

.choose{
  border:2px solid #315cc5;
  background:#f5f8ff;
}

.play-item.disabled{
  opacity:.5;
  pointer-events:none;
}

/* ==========金额栏美化========== */
.money-bar{
  height:72px;
  display:flex;
  align-items:center;
  gap:10px;
  padding:10px 14px;
  background:#f7f8fa;
}

.money-bar button{
  flex:1;
  height:48px;
  border:0;
  border-radius:10px;
  background:#ffffff;
  font-size:16px;
  color:#333;
  box-shadow:0 1px 4px rgba(0,0,0,0.08);
  transition:0.2s;
}

.money-bar button:active{
  transform:scale(0.96);
}

.money-bar button:disabled{
  opacity:.45;
  transform:none;
}

.money-bar .active{
  background:linear-gradient(135deg,#3b7bff,#204fc9);
  color:#fff;
}

.money-input{
  width:106px;
  height:48px;
  border:1px solid #dde1e8;
  border-radius:10px;
  padding:0 12px;
  font-size:16px;
  outline:none;
  background:#fff;
}

.money-input:disabled{
  background:#eee;
}

/* =========底部下注栏美化========= */
.footer{
  height:86px;
  display:flex;
  align-items:center;
  gap:12px;
  padding:12px 16px;
  background:#fff;
  box-shadow:0 -2px 10px rgba(0,0,0,0.06);
}

.total{
  flex:1;
  height:54px;
  border-radius:12px;
  background:#f3f6fc;
  display:flex;
  align-items:center;
  padding-left:16px;
  font-size:16px;
  color:#222;
}
.total b{
  color:#e64340;
  font-size:18px;
  margin:0 4px;
}

.clear{
  width:96px;
  height:54px;
  background:#f4f5f7;
  border:none;
  border-radius:12px;
  font-size:16px;
  color:#555;
}

.submit{
  width:170px;
  height:54px;
  border:0;
  border-radius:12px;
  background:linear-gradient(135deg,#ff7849,#f54338);
  color:#fff;
  font-size:17px;
  font-weight:bold;
  box-shadow:0 4px 12px rgba(245,67,56,0.25);
  transition:0.2s;
}
.submit:active{
  transform:scale(0.97);
}
.submit:disabled{
  background:#bbbbbb;
  box-shadow:none;
  transform:none;
}
</style>

<style>
.history-mask{
  position:fixed;
  inset:0;
  background:rgba(0,0,0,0.45);
  z-index:99999;
  display:flex;
  align-items:flex-start;
  justify-content:center;
  padding-top:240px;
}
.history-popup{
  width:92%;
  max-width:420px;
  background:#fff;
  border-radius:14px;
  overflow:hidden;
}
.history-title{
  text-align:center;
  font-size:17px;
  font-weight:bold;
  padding:14px;
  border-bottom:1px solid #eee;
}
.history-list{
  max-height:320px;
  overflow-y:auto;
}
.history-loading{
  text-align:center;
  padding:24px;
  color:#888;
}
.history-item{
  display:flex;
  align-items:center;
  gap:10px;
  padding:12px 16px;
  border-bottom:1px solid #f2f2f2;
}
.history-item .period{
  min-width:80px;
}
.balls-mini{
  display:flex;
  gap:6px;
}
.balls-mini b{
  width:28px;
  height:28px;
  border-radius:50%;
  background:linear-gradient(#00d2e9,#0084c7);
  color:#fff;
  display:flex;
  justify-content:center;
  align-items:center;
  font-size:14px;
}
.balls-mini em{
  width:28px;
  height:28px;
  border-radius:50%;
  background:#ff663f;
  color:#fff;
  display:flex;
  justify-content:center;
  align-items:center;
  font-size:14px;
  font-style:normal;
}
</style>


// WEBPACK FOOTER //
// src/components/game28.vue